module.exports = __webpack_public_path__ + "static/media/Mountain.afc581aa.png";